import { withStyles } from '@material-ui/core';
import ProfitCenter from './ProfitCenter';
import styles from './styles';

export default withStyles(styles)(ProfitCenter);
